import { BehaviorParameters } from 'rangeConfig/@types';
import { ComponentIds, Entity, HierarchyUtils } from '@inter-ikea-core/core';
import { BestaOpeningFunctionComponent } from '@inter-ikea-storageone/range-besta';
import { ErrorMessages, ProductType } from '@inter-ikea-storageone/range';
import { getMajorityProduct } from 'rangeConfig/shared/utils/frontLayouts';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';

const getMajorityHandleOnEntities = (entities: Entity[]): string | null => {
  const handlesOnEntities = entities
    .map(entity =>
      HierarchyUtils.findInHierarchy(entity, (e: Entity) =>
        e.hasComponent(ComponentIds.HANDLE_COMPONENT_ID)
      )
    )
    .filter((handle): handle is Entity => !!handle);
  return getMajorityProduct(handlesOnEntities);
};

const addFront = ({ coreApi, props }: BehaviorParameters) => {
  const placementResult = coreApi.products.add(props.coreProductId, props.position);
  if (!placementResult.valid && placementResult.errors && placementResult.errors.length > 0) {
    if (!hideNoFramesInSceneErrorMessage(coreApi)) {
      coreApi.emit.onPlacementAttempt(ErrorMessages.NoFramesInScene);
    }
    coreApi.entities.disposeCollidingEntities(placementResult.errors);
  } else {
    if (
      placementResult.placedEntity?.hasComponent(ComponentIds.DRAWER_COMPONENT_ID) &&
      placementResult.placedEntity?.getComponent<BestaOpeningFunctionComponent>(
        BestaOpeningFunctionComponent.id
      )?.openingFunction === ProductType.BESTA_SOFT_CLOSING
    ) {
      // Soft closing drawer added. Add majority handle from other drawers in scene
      const drawersInScene = coreApi.entities.getByComponent(ComponentIds.DRAWER_COMPONENT_ID);
      const majorityHandle = getMajorityHandleOnEntities(drawersInScene);
      if (majorityHandle) {
        coreApi.products.addToTarget(majorityHandle, placementResult.placedEntity);
      }
    } else if (placementResult.placedEntity?.hasComponent(ComponentIds.DOOR_COMPONENT_ID)) {
      // Door added. Add majority handle from other doors in scene
      const doorsInScene = coreApi.entities.getByComponent(ComponentIds.DOOR_COMPONENT_ID);
      const majorityHandle = getMajorityHandleOnEntities(doorsInScene);
      if (majorityHandle) {
        coreApi.products.addToTarget(majorityHandle, placementResult.placedEntity);
      }
    }
  }
};

export { addFront };
